/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {XhrHttpModule} from "@intuitionrobotics/thunderstorm/frontend";
import {HttpMethod} from "@intuitionrobotics/thunderstorm";
import {Module} from "@intuitionrobotics/ts-common";
import {DB_User} from "@app/ir-q-app-common/types/care-center/user";
import {AccountApi_AddNewAccount, Request_AddNewAccount} from "@app/app-shared/api";

class KasperAccountModule_Class
	extends Module {
	create = (userDetails: Request_AddNewAccount, onExecute?: (user: DB_User) => void) => {
		 XhrHttpModule
			.createRequest<AccountApi_AddNewAccount>(HttpMethod.POST, "add-new-account")
			.setJsonBody(userDetails)
			.setRelativeUrl("/v1/account/add-new-account")
			.setOnError("error creating user in kaspero")
			.execute((user: DB_User) => {
				if (onExecute) {
					onExecute(user);
				}
			});
	};
}

export const KasperAccountModule = new KasperAccountModule_Class("KasperAccountModule");
